import type { ComponentProps } from 'react';
import { cx } from '@/lib/format';

const field =
  'w-full rounded-md border border-line-strong bg-bg-elev px-3 text-sm text-fg placeholder:text-fg-subtle focus:border-accent focus:outline-none disabled:opacity-50';

export function Input({ className, ...rest }: ComponentProps<'input'>) {
  return <input className={cx(field, 'h-9', className)} {...rest} />;
}
export function Textarea({ className, ...rest }: ComponentProps<'textarea'>) {
  return <textarea className={cx(field, 'py-2 min-h-[72px] resize-y', className)} {...rest} />;
}
export function Select({ className, children, ...rest }: ComponentProps<'select'>) {
  return (
    <select className={cx(field, 'h-9 pr-8', className)} {...rest}>
      {children}
    </select>
  );
}
export function Label({ children, htmlFor, className }: { children: React.ReactNode; htmlFor?: string; className?: string }) {
  return (
    <label htmlFor={htmlFor} className={cx('mb-1 block text-xs font-medium text-fg-muted', className)}>
      {children}
    </label>
  );
}
